// extracted by mini-css-extract-plugin
export default {"container":"MainContainer_container__+2R6x"};